import { Constants } from "@eagerdog/constants";

import { validateStopWatchTime } from "./helpers/time";

/**
 * Generic search-time validity check — ported from EnterResults.hasValidSearchTime.
 * `results` is the single result object; `scentworkResults` the multi-result array
 * (only used for scentwork).
 */
export const hasValidSearchTime = (
  showType: string,
  results: any,
  scentworkResults: any[] = []
): boolean => {
  if (showType === Constants.show_type.weight_pull) {
    return true;
  }

  if (results && results.result_type !== Constants.score_result_type.qualified) {
    return true;
  }

  // Precision Coursing: time is optional even when qualified
  if (showType === Constants.show_type.precision_coursing) {
    if (!results || !results.search_time || results.search_time === "") {
      return true;
    }
    return validateStopWatchTime(results.search_time);
  }

  if (showType === Constants.show_type.scentwork) {
    for (const scentworkResult of scentworkResults) {
      if (
        scentworkResult &&
        scentworkResult.result_type !== Constants.score_result_type.qualified
      ) {
        return true;
      }

      if (
        scentworkResult &&
        (scentworkResult.search_time || scentworkResult.search_time === "") &&
        scentworkResult.search_time.split !== undefined
      ) {
        if (!validateStopWatchTime(scentworkResult.search_time)) {
          return false;
        }
      }
    }
  }

  if (
    [Constants.show_type.fast_cat, Constants.show_type.water_dog].includes(
      showType
    )
  ) {
    return !!(results && results.time && results.time.toString().length > 0);
  } else {
    if (
      results &&
      (results.search_time || results.search_time === "") &&
      results.search_time.split !== undefined
    ) {
      return validateStopWatchTime(results.search_time);
    } else if (
      results &&
      (isNaN(results.search_time) || results.search_time === 0) &&
      results.search_time &&
      results.search_time.split === undefined
    ) {
      const isNumber = parseInt(results.search_time, 10);

      if (isNaN(isNumber) || results.search_time === 0) {
        return false;
      }
    } else if (results && results.time) {
      const isNumber = parseInt(results.time, 10);

      if (isNaN(isNumber)) {
        return false;
      }
    } else {
      return true;
    }
  }

  return true;
};

/**
 * Generic course-time validity check — ported from EnterResults.hasValidCourseTime.
 */
export const hasValidCourseTime = (
  showType: string,
  results: any,
  scentworkResults: any[] = []
): boolean => {
  if (showType === Constants.show_type.scentwork) {
    for (const scentworkResult of scentworkResults) {
      if (
        scentworkResult &&
        scentworkResult.result_type !== Constants.score_result_type.qualified
      ) {
        return true;
      }

      if (
        scentworkResult &&
        (scentworkResult.time_limit || scentworkResult.time_limit === "") &&
        scentworkResult.time_limit.split !== undefined
      ) {
        if (!validateStopWatchTime(scentworkResult.time_limit)) {
          return false;
        }
      }
    }
  }

  if (
    results &&
    (results.course_time || results.course_time === "") &&
    results.course_time.split !== undefined
  ) {
    return validateStopWatchTime(results.course_time);
  }

  return true;
};

/**
 * Generic result-type presence check — ported from EnterResults.validateResultType.
 */
export const hasResultType = (
  showType: string,
  results: any,
  scentworkResults: any[] = []
): boolean => {
  if (showType === Constants.show_type.scentwork) {
    let valid = false;
    for (const scentworkResult of scentworkResults) {
      valid = !!(scentworkResult && scentworkResult.result_type !== "None");
    }
    return valid;
  }

  return !!(results && results.result_type !== "None");
};
